import { render } from "./EditViewersIcon.vue?vue&type=template&id=3c7b8a59"
import script from "./EditViewersIcon.vue?vue&type=script&lang=js"
export * from "./EditViewersIcon.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__